import {HomeHandler} from './home/home';

HomeHandler.init()
